import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalSaveFabricComment: ExperimentalMutations['experimentalSaveFabricComment'] =
	(_, args, { network }) => {
		const {
			location,
			contentType,
			contentId,
			adfContent,
			commentId,
			requestType,
			version,
			// TODO FIXME `args.params` can be `null` or `undefined` according to experimental schema. Either this
			// case needs to be properly handled, or the schema type needs to be fixed
		} = args.params!;

		const commentsData = {
			id: commentId || null,
			ancestors: requestType === 'replyComment' ? [{ id: commentId }] : [],
			body: {
				atlas_doc_format: {
					representation: 'atlas_doc_format',
					value: adfContent,
				},
			},
			container: {
				type: contentType,
				id: contentId,
			},
			extensions: { location },
			type: 'comment',
			version,
		};

		let url, method;

		switch (requestType) {
			case 'editComment':
				method = 'PUT';
				url = `/wiki/rest/api/content/${commentId}?expand=container,ancestors,extensions`;
				break;
			default:
				method = 'POST';
				url = `/wiki/rest/api/content?expand=container,ancestors,extensions`;
				break;
		}

		return fetchJSON(network, url, {
			method,
			headers: {
				'Content-Type': MediaType.JSON,
				'X-Atlassian-Token': 'no-check',
			},
			body: JSON.stringify(commentsData),
		});
	};
